import { useQuery } from "@tanstack/vue-query";
import { useI18n } from "vue-i18n";
import type { MaybeRef } from "vue";
import { api } from "@/helpers/api";
import brandconfig from "@/brandconfig";
import {
  createApiQueryByIdFn,
  createListQueryFn,
  EventsApi,
  useApiQuery,
  type APIQueryOptions,
  type EventsportalcacheGetRequest,
} from "@xs2event/js-lib/api";

const TODAY = new Date().toISOString().substr(0, 10);
const eventsApi = new EventsApi();

export const usePopularEvents = () => {
  const { locale } = useI18n();

  return useQuery({
    queryKey: ["popular-events", locale],
    queryFn: async () => {
      const params = new URLSearchParams(brandconfig.quicklist.params || {});
      params.append("date_stop", "ge:" + TODAY);
      params.append("tickets_available", "ge:1");
      params.append("ticket_price_eur", "ge:1");
      params.append("popular_events", true);
      params.append("event_status", "in:[nosale,notstarted,postponed]");
      //params.append('sport_type', 'motorsport')
      params.append("page_size", 5);
      const response = await api.get("/events?" + params);
      // console.log(response.data.events)
      return response.data.events;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};

export const useEvents = createListQueryFn(eventsApi, "eventsGet");

/**
 * Every upcoming event (date_start >= today, any status except closed), priced for the calling
 * distributor. Takes no filters and no pagination — the portal filters and sorts client side.
 */
export const usePortalEventsCache = (payload?: MaybeRef<EventsportalcacheGetRequest>, options?: APIQueryOptions) =>
  useApiQuery(eventsApi, "eventsportalcacheGet", payload, { debounce: false, ...options });

export const useGetEventsByIds = createApiQueryByIdFn(eventsApi, "eventsGet", "eventId");
